import VerifiedIcon from '@mui/icons-material/Verified';
import ContractorManagement from './ContractorManagement';

export default {
    icon:  VerifiedIcon,
    recordRepresentation: 'reference',
    list: ContractorManagement
}